import { Tabs, Tab, Box, Tooltip, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { selectIsUpdating, setUpdating } from "./bidSlice";
import { useDispatch } from "react-redux";
import { request } from "@/Api";
import { store } from "./bidStore";

export default function BidSheetTabs({
    running,
    runningInitialized,
    handleToggleRunning,
}) {
    const dispatch = useDispatch();
    const bidId = store.bid.id;
    const isTemplate = store.bid.project_id == null;
    const updating = useSelector(selectIsUpdating);

    const initializeRunning = () => {
        if (runningInitialized || !bidId || isTemplate) {
            return;
        }
        request.post(`/bids/${bidId}/reset-running`).then(() => {
            dispatch(setUpdating(false));
        });
        dispatch(setUpdating(true));
    };

    return (
        <Box sx={{ width: "100%" }}>
            <Box>
                <Tabs
                    sx={{
                        borderBottom: 1,
                        color: "grey",
                        marginBottom: 1.5,
                        minHeight: 0,
                        padding: 0,
                    }}
                    value={running ? 1 : 0}
                    onChange={(e, v) => handleToggleRunning(v)}
                >
                    <Tab
                        value={0}
                        label="Quoted"
                        sx={{ fontSize: 12 }}
                        disabled={updating}
                    />

                    <Tab
                        onClick={initializeRunning}
                        value={1}
                        label="Running"
                        disabled={updating}
                        sx={{ fontSize: 12 }}
                    />
                </Tabs>
            </Box>
        </Box>
    );
}

/**
 * Using the `disabled` prop on a Tab breaks the Tooltip, but this hack works
 * https://github.com/mui/material-ui/issues/12597#issuecomment-455244379
 */
const ToolTipTab = ({ children, ...props }) => {
    return children(props);
};
